import { css } from '@emotion/css';

export const styBannerContainer = ({
  emailVerified,
  userNotKycYet,
  stockKycVerifying,
  stockKycError,
}) => css`
  padding: 0px 16px;
  margin-bottom: 12px;
  width: 350px;
  height: 88px;
  margin-top: ${(!userNotKycYet || !emailVerified) && !stockKycVerifying && !stockKycError
    ? '12px'
    : '48px'};
`;
